import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Debug log pour identifier les problèmes
  console.log('[KadmiAi Route] ProtectedRoute check:', { loading, hasUser: !!user });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background dark:bg-slate-950">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground text-sm">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('[KadmiAi Route] No user found, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  return children;
};
